<template>
    <!--TOI Sessions-->
    <div>
        <!--statistics-->
        <div v-if="!isLoading && analytics.usage.topicData.length > 0" class="line-item statistics">
            <div class="statistic">
                <strong>{{ analytics.total }}</strong>
                <span>Peak Usage</span>
            </div>
            <div class="statistic">
                <strong>{{ analytics.usage.topicData ? analytics.usage.topicData.length : '' }}</strong>
                <span>Topics</span>
            </div>
        </div>
        <!--graph-->
        <div v-if="!isLoading" class="analytics-chart">
            <line-chart
                id="topicChart" ref="chart" v-if="analytics.usage.topicData"
                :curve="false" :data="analytics.usage.topicData" :discrete="true" lineWidth="1" legend="none"
                :refresh="5" height="400px"
            />
            <div v-else-if="!isLoading" class="centered">No Analytics data for period.</div>
        </div>
        <!--data table-->
        <div v-if="!isLoading" class="data-table">
            <template v-if="false">
                <div>
                    <md-table v-if="analytics.usage.topicData" v-model="analytics.usage.topicData" md-card>
                        <md-table-toolbar>
                            <h1 class="md-title">Topics</h1>
                        </md-table-toolbar>
                        <md-table-row slot="md-table-row" slot-scope="{ row }">
                            <md-table-cell md-label="Topic of Interest" md-sort-by="name">{{ row.name }}</md-table-cell>
                            <md-table-cell md-label="Peak User Sessions" md-sort-by="sessions">{{ row.sessions }}</md-table-cell>
                        </md-table-row>
                    </md-table>
                </div>
            </template>
            <table>
                <thead>
                <tr>
                    <th>
                        <span class="sort-el">
                            <a>Topic of Interest</a>
                        </span>
                    </th>
                    <th class="right-align half-cell">
                        <span class="sort-el">
                            <a>Peak User Sessions</a>
                        </span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(topic, index) in analytics.usage.topicData" :key="index">
                    <td>
                        <md-icon class="marker" v-bind:style="{ color: topic.color }">fiber_manual_record</md-icon>
                        {{ topic.name }}
                    </td>
                    <td class="right-align">{{ topic.total }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  data () {
    return {
      chart: null
    };
  },
  computed: {
    ...mapGetters('analytics', {analytics: 'analytics', colors: 'getColors', isLoading: 'isLoading'})
  },
  methods: {
    redrawChart (data) {
      if (this.chart) {
        this.chart.chart.data = data;
      }
    },
    toggleLanguage ($language) {

    },
    drawChart (data) {
      let dataTable = new google.visualization.DataTable();
      let rows = [];
      for (let line of data) {
        dataTable.addColumn('number', line.name);
        rows.push(line.data);
        dataTable.addRows(line.data);
      }
      let options = {
        curveType: 'function'
      };

      let chart = new google.visualization.LineChart(document.getElementById('chart'));
      chart.draw(dataTable, options);
    }
  },
  async mounted () {
    this.chart = this.$refs.chart;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/AnalyticsTopic.vue